// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__zPDbe","header":"MergedInvoice_header__MZQ31"};